import { AlertCircleIcon } from '@/lib';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const UnifiedProfileListSourceMessage: FC = () => {
  const { t } = useTranslation('unifiedProfile');

  return (
    <div className='flex items-center gap-2 text-xs'>
      <div className='rounded-full border-2 p-0.5 text-tertiary-600/20'>
        <div className='rounded-full border-2 p-0.5 text-tertiary-600/60'>
          <AlertCircleIcon className='relative z-10 size-5 text-tertiary-600' aria-hidden='true' />
        </div>
      </div>
      <p className='text-xs text-quaternary-500'>{t('unifiedProfilesSubtitleWarning')}</p>
    </div>
  );
};
